<template>
	<div class="popup-wrap">
		<!-- 저장 중에는 배경/X 로 닫히지 않게 한다. 닫고 다시 열어 저장하면 같은 계약이 두 건 만들어진다. -->
		<div class="dim" @click="tryClose"></div>
		<div class="popup md">
			<div class="popup-tit">
				{{ isEdit ? '계약 정보 수정' : '계약 등록' }}
				<button type="button" class="btn btn-close" @click="tryClose"><b-icon-x-lg /></button>
			</div>
			<div class="popup-con">
				<table class="table type2">
					<colgroup>
						<col width="18%" /><col width="32%" /><col width="18%" /><col width="32%" />
					</colgroup>
					<tr>
						<th>계약명 <span class="txt-c--red">*</span></th>
						<td colspan="3"><input type="text" class="form-control" v-model="form.title" maxlength="200" /></td>
					</tr>
					<tr>
						<th>구분</th>
						<td>
							<select v-model="form.item_kind" class="form-control select" @change="onKindChange">
								<option value="building">매매</option>
								<option value="rent_building">임대</option>
							</select>
						</td>
						<th>상태</th>
						<td>
							<select v-model="form.contract_status" class="form-control select">
								<option v-for="s in STATUS_LIST" :key="'fst_' + s.value" :value="s.value">{{ s.label }}</option>
							</select>
						</td>
					</tr>
					<tr>
						<th>연결 매물</th>
						<td colspan="3">
							<div v-if="form.building_uid">
								<!-- 물건번호를 함께 표시 — 직원들이 매물을 번호로 부르는데 카드에 번호가 없어
								     BoardWrite 선택 카드와도 비대칭이었다(평가 지적 B2). -->
								<b v-if="selectedItem">
									[{{ form.item_kind === 'rent_building' ? '임대' : '매매' }}] #{{ form.building_uid }}
									{{ selectedItem.building_name }}
								</b>
								<b v-else class="txt-c--red">매물 #{{ form.building_uid }} (원본 정보 없음)</b>
								<span v-if="selectedItem" class="txt-c--grey m-l--1">
									{{ $normalizeAddr(selectedItem.jibun_addr) }}
								</span>
								<button type="button" class="btn btn-xsm btn-light m-l--1" @click="openOrigin" v-if="selectedItem">
									원본 상세보기
								</button>
								<button type="button" class="btn btn-xsm btn-light m-l--1" @click="clearItem">연결 해제</button>
							</div>
							<div v-else class="txt-c--grey">연결된 매물이 없습니다. (매물 없이도 계약 등록 가능)</div>

							<div class="search-top mt-1">
								<div class="left">
									<input
										type="text"
										class="form-control xsm"
										v-model="itemSearch.bid"
										placeholder="물건번호"
										@keyup.enter="searchItem"
									/>
									<input
										type="text"
										class="form-control sm"
										v-model="itemSearch.name"
										placeholder="물건명"
										@keyup.enter="searchItem"
									/>
									<input
										type="text"
										class="form-control sm"
										v-model="itemSearch.addr"
										placeholder="주소"
										@keyup.enter="searchItem"
									/>
									<button type="button" class="btn btn-sm btn-secondary" @click="searchItem">매물검색</button>
								</div>
							</div>
							<div v-if="searchList.length" class="table-wrap ct-form--items">
								<table class="table click">
									<tr>
										<th>물건번호</th>
										<th>물건명</th>
										<th>주소</th>
										<th>매매가</th>
										<th>담당</th>
									</tr>
									<tr v-for="it in searchList" :key="'sit_' + it.building_uid" @click="selectItem(it)">
										<td>{{ it.building_uid }}</td>
										<td class="txt-left">{{ it.building_name }}</td>
										<td class="txt-left">{{ $normalizeAddr(it.jibun_addr) }}</td>
										<td>{{ $formatMoney(it.sell_price, $MONEY_FORMAT_TYPE.MUCH) }}</td>
										<td>{{ it.building_mem_name }}</td>
									</tr>
								</table>
							</div>
							<div v-else-if="searched" class="txt-c--grey mt-1">검색 결과가 없습니다.</div>
						</td>
					</tr>
					<tr>
						<th>매매금액</th>
						<td colspan="3">
							<input type="text" class="form-control sm" v-model="sellPriceText" @input="onPriceInput" />
							<span class="txt-c--grey m-l--1">
								만원 {{ form.sell_price ? '· ' + $formatMoney(form.sell_price, $MONEY_FORMAT_TYPE.MUCH) : '' }}
							</span>
						</td>
					</tr>
					<tr>
						<th>계약일</th>
						<td><input type="date" class="form-control" v-model="form.contract_date" /></td>
						<th>본계약일</th>
						<td><input type="date" class="form-control" v-model="form.main_contract_date" /></td>
					</tr>
					<tr>
						<th>잔금일</th>
						<td><input type="date" class="form-control" v-model="form.balance_date" /></td>
						<th></th>
						<td class="txt-c--grey">잔금일 변경 시 참여자에게 알림이 발송됩니다.</td>
					</tr>
					<tr>
						<th>매수인</th>
						<td><input type="text" class="form-control" v-model="form.buyer_name" maxlength="100" /></td>
						<th>매도인</th>
						<td><input type="text" class="form-control" v-model="form.seller_name" maxlength="100" /></td>
					</tr>
					<tr>
						<th>메모</th>
						<td colspan="3"><textarea class="form-control" rows="3" v-model="form.memo"></textarea></td>
					</tr>
					<!-- 첨부(계약서 등)도 저장 버튼 한 번으로 함께 등록된다.
					     예전에는 계약을 먼저 등록한 뒤 상세 화면에서 따로 올려야 했다. -->
					<tr>
						<th>첨부파일</th>
						<td colspan="3">
							<!-- 파일 선택은 앱의 버튼 스타일로 통일(계약 상세·게시글 작성과 동일). -->
							<input type="file" ref="fileInput" class="d-none" multiple @change="onFilePick" :disabled="saving" />
							<div class="d-flex align-items-center">
								<button
									type="button"
									class="btn btn-sm btn-secondary"
									@click="$refs.fileInput.click()"
									:disabled="saving"
									aria-describedby="ctFilePicked"
								>
									파일 선택
								</button>
								<!-- 숨긴 input 대신 이 문구가 선택 상태를 낭독기에 알린다. -->
								<span id="ctFilePicked" class="txt-c--grey m-l--1" role="status" aria-live="polite">
									{{ pickedFiles.length ? pickedFiles.length + '개 선택됨' : '선택된 파일 없음' }}
								</span>
							</div>
							<div class="txt-c--grey">파일당 최대 {{ maxMb }}MB · 저장을 누르면 계약과 함께 등록됩니다.</div>
							<!-- 팝업에는 이미 올라간 파일 목록이 없어(계약 상세에 있다) 개수만이라도 알려준다. -->
							<div v-if="uploadedCount" class="txt-c--blue">
								이미 등록된 첨부 {{ uploadedCount }}개 — 계약 상세에서 확인·삭제할 수 있습니다.
							</div>
							<div class="table-wrap mt-1" v-if="pickedFiles.length">
								<table class="table sm">
									<colgroup>
										<col /><col width="20%" /><col width="14%" />
									</colgroup>
									<tr>
										<th>등록할 파일</th>
										<th>크기</th>
										<th>제거</th>
									</tr>
									<tr v-for="(f, i) in pickedFiles" :key="'cpf_' + i + '_' + f.name">
										<td class="txt-left">{{ f.name }}</td>
										<td>{{ sizeText(f.size) }}</td>
										<td>
											<button type="button" class="btn btn-xsm btn-light" @click="removePicked(i)" :disabled="saving">
												제거
											</button>
										</td>
									</tr>
								</table>
							</div>
						</td>
					</tr>
				</table>
				<div class="txt-c--grey mt-1">
					※ 매물 정보(주소 · 금액 · 상태)는 복사 저장하지 않고 원본 매물에서 조회합니다.
					<span v-if="!isEdit">등록 시 기본 체크리스트가 자동 생성되고, 등록자는 계약관리 담당자로 등록됩니다.</span>
				</div>
			</div>
			<div class="popup-btn">
				<div class="txt-c--grey mb-1" v-if="progressText">{{ progressText }}</div>
				<!-- 첨부 업로드 구간에서는 취소 대신 "중단" 을 제공한다(계약 저장 요청 중에는 끊을 게 없다). -->
				<button v-if="!saving" type="button" class="btn btn-light" @click="tryClose">
					{{ persistedUid ? '닫기' : '취소' }}
				</button>
				<button v-else-if="uploadPhase" type="button" class="btn btn-light" @click="btnStop" :disabled="cancelRequested">
					{{ cancelRequested ? '중단 중…' : '중단' }}
				</button>
				<button v-else type="button" class="btn btn-light" disabled>취소</button>
				<button type="button" class="btn btn-primary" @click="btnSave" :disabled="saving">
					{{ saving ? '등록 중…' : '저장' }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
const STATUS_LABEL = { ing: '계약진행', ready: '잔금준비', done: '잔금완료', delay: '연기', cancel: '해제' };
const STATUS_LIST = Object.keys(STATUS_LABEL).map(k => ({ value: k, label: STATUS_LABEL[k] }));

export default {
	name: 'ContractForm',
	props: {
		contractUid: { type: [Number, String], default: null },
		initial: { type: Object, default: null },
	},
	emits: ['close', 'saved'],
	data() {
		return {
			STATUS_LIST,
			saving: false,
			cancelRequested: false,
			// 첨부를 실제로 올리는 구간에서만 "중단" 을 노출한다.
			uploadPhase: false,
			// 이 팝업에서 지금까지 업로드에 성공한 첨부 수(중단·부분실패 후 안내용).
			uploadedCount: 0,
			progressText: '',
			// 저장 버튼을 누를 때 함께 올릴 첨부 대기 목록(성공분은 제거, 실패분만 남긴다).
			pickedFiles: [],
			maxMb: 200,
			// 등록에는 성공했지만 첨부 업로드에서 실패해 사용자가 저장을 다시 누르는 경우,
			// 계약이 중복 생성되지 않도록 새로 만들어진 uid 를 기억한다.
			savedUid: null,
			// 등록/수정 중 한 번이라도 저장에 성공했는지(닫을 때 부모를 갱신해야 하는지 판단).
			persistedUid: null,
			itemSearch: { bid: '', name: '', addr: '' },
			searchList: [],
			searched: false,
			selectedItem: null,
			sellPriceText: '',
			form: {
				title: '',
				item_kind: 'building',
				building_uid: null,
				sell_price: null,
				contract_date: '',
				main_contract_date: '',
				balance_date: '',
				buyer_name: '',
				seller_name: '',
				contract_status: 'ing',
				memo: '',
			},
		};
	},
	computed: {
		isEdit() {
			return this.contractUid !== null && this.contractUid !== '';
		},
	},
	created() {
		if (!this.initial) return;
		const s = this.initial;
		this.form = {
			title: s.title || '',
			item_kind: s.item_kind || 'building',
			building_uid: s.building_uid || null,
			sell_price: s.sell_price === null || s.sell_price === undefined ? null : Number(s.sell_price),
			contract_date: this.dateInput(s.contract_date),
			main_contract_date: this.dateInput(s.main_contract_date),
			balance_date: this.dateInput(s.balance_date),
			buyer_name: s.buyer_name || '',
			seller_name: s.seller_name || '',
			contract_status: s.contract_status || 'ing',
			memo: s.memo || '',
		};
		this.sellPriceText = this.form.sell_price === null ? '' : String(this.form.sell_price);
		// C-1: 원본 매물이 삭제된 계약은 카드를 비워두지 않고 명시적으로 알린다(게시판 B-12 와 같은 원칙).
		if (s.building_uid && !s.item_deleted && s.item_name) {
			this.selectedItem = {
				building_uid: s.building_uid,
				building_name: s.item_name,
				jibun_addr: s.item_jibun_addr,
				sell_price: s.item_sell_price,
				building_mem_name: s.item_mgr_name,
			};
		}
	},
	methods: {
		dateInput(v) {
			if (!v) return '';
			return String(v).slice(0, 10);
		},
		onPriceInput() {
			const n = String(this.sellPriceText).replace(/[^0-9]/g, '');
			this.sellPriceText = n;
			this.form.sell_price = n === '' ? null : Number(n);
		},
		onKindChange() {
			this.searchList = [];
			this.searched = false;
		},
		searchItem() {
			// 빈 검색어는 쿼리에서 아예 뺀다 — 공통 bid-guard(J-2, backend/routes/index.js)가
			// bid='' 를 400 으로 차단해서, 빈 bid 를 함께 보내면 물건명·주소 단독 검색이 통째로 막힌다.
			const q = new URLSearchParams({ kind: this.form.item_kind });
			for (const [k, v] of Object.entries(this.itemSearch)) {
				const t = String(v || '').trim();
				if (t) q.set(k, t);
			}
			if (!q.has('bid') && !q.has('name') && !q.has('addr')) {
				alert('물건번호 · 물건명 · 주소 중 하나를 입력하세요.');
				return;
			}
			this.$apiGET('/admin/api/board/item/search?' + q.toString()).then(re => {
				this.searched = true;
				this.searchList = Array.isArray(re) ? re : [];
			});
		},
		selectItem(it) {
			this.form.building_uid = it.building_uid;
			this.selectedItem = it;
			if (this.form.sell_price === null && it.sell_price) {
				this.form.sell_price = Number(it.sell_price);
				this.sellPriceText = String(this.form.sell_price);
			}
			if (!this.form.title) this.form.title = it.building_name || '';
			this.searchList = [];
			this.searched = false;
		},
		clearItem() {
			this.form.building_uid = null;
			this.selectedItem = null;
		},
		openOrigin() {
			if (!this.selectedItem) return;
			const target = this.form.item_kind === 'rent_building' ? '/LeaseMapDetail/' : '/MapDetail/';
			const w = window.screen.availWidth;
			const h = window.screen.availHeight;
			window.open(target + this.selectedItem.building_uid, '', `width=${w}, height=${h}, resizable=no, status=no`);
		},
		onFilePick(e) {
			const files = e.target.files ? Array.from(e.target.files) : [];
			const tooBig = [];
			for (const f of files) {
				// 서버(multer) 상한과 같은 값을 미리 걸러 "계약은 등록됐는데 파일만 실패" 를 줄인다.
				if (f.size > this.maxMb * 1024 * 1024) {
					tooBig.push(f.name);
					continue;
				}
				// 이름+크기가 같아도 서로 다른 파일일 수 있어(다른 폴더의 동명 계약서 등) 조용히 버리지 않는다.
				this.pickedFiles.push(f);
			}
			if (tooBig.length) alert(`다음 파일은 ${this.maxMb}MB 를 넘어 제외했습니다.\n${tooBig.join(', ')}`);
			if (this.$refs.fileInput) this.$refs.fileInput.value = '';
		},
		removePicked(i) {
			this.pickedFiles.splice(i, 1);
		},
		sizeText(size) {
			const n = Number(size) || 0;
			if (n >= 1024 * 1024) return (n / 1024 / 1024).toFixed(1) + 'MB';
			if (n >= 1024) return Math.round(n / 1024) + 'KB';
			return n + 'B';
		},
		// 남길 목록은 파일명이 아니라 File 객체 기준으로 고른다(같은 이름의 다른 파일이 섞여도 정확).
		// 반환값: { failed:[파일명], aborted:'auth'|'user'|null, done:업로드성공수 }
		async uploadPicked(uid) {
			const queue = this.pickedFiles.slice();
			const stillFailed = [];
			let aborted = null;
			let done = 0;
			this.uploadPhase = queue.length > 0;
			for (let i = 0; i < queue.length; i++) {
				if (this.cancelRequested) {
					aborted = 'user';
					stillFailed.push(...queue.slice(i));
					break;
				}
				const f = queue[i];
				this.progressText = `첨부파일 업로드 중… (${i + 1}/${queue.length}) ${f.name}`;
				// $apiFILE 은 (path, bid, fileObj, fileName) 시그니처. 백엔드가 contractUid || bid 를 모두 받는다.
				const re = await this.$apiFILE('/admin/api/contract/file/add', uid, f, f.name);
				// 401 이면 $apiFILE 이 로그인 화면으로 보낸 상태다 → 남은 업로드를 멈춘다.
				if (re === undefined) {
					aborted = 'auth';
					stillFailed.push(...queue.slice(i));
					break;
				}
				if (re !== true) stillFailed.push(f);
				else done++;
			}
			this.pickedFiles = stillFailed;
			this.uploadPhase = false;
			this.uploadedCount += done;
			this.progressText = '';
			return { failed: stillFailed.map(f => f.name), aborted, done };
		},
		btnStop() {
			this.cancelRequested = true;
			this.progressText = '중단 요청됨 — 현재 파일까지만 올립니다…';
		},
		tryClose() {
			if (this.saving) {
				alert('등록이 진행 중입니다. 완료되거나 "중단" 을 누른 뒤에 닫아주세요.');
				return;
			}
			// 첨부 실패·중단으로 팝업이 열려 있어도 계약 저장(등록이든 수정이든)은 이미 반영돼 있다.
			// 그냥 close 로 닫으면 부모가 갱신되지 않아 (등록) 목록에 안 보이거나 (수정) 상세가 옛 값을
			// 그대로 보여주고, 그 화면에서 다시 수정창을 열어 저장하면 방금 저장한 값이 되돌아간다.
			// → 한 번이라도 저장에 성공했으면 saved 로 알려 부모가 이동/갱신하게 한다.
			if (this.persistedUid) {
				this.$emit('saved', this.persistedUid);
				return;
			}
			this.$emit('close');
		},
		async btnSave() {
			if (this.saving) return; // 진행 중 재클릭 차단(버튼 disabled 와 이중 안전망)
			if (!this.form.title || !this.form.title.trim()) {
				alert('계약명을 입력하세요.');
				return;
			}
			const uid = this.isEdit ? this.contractUid : this.savedUid;
			const isUpdate = uid !== null && uid !== '' && uid !== undefined;
			const body = JSON.parse(JSON.stringify(this.form));
			body.title = body.title.trim();
			if (isUpdate) body.contractUid = uid;
			const url = isUpdate ? '/admin/api/contract/update' : '/admin/api/contract/add';

			this.saving = true;
			this.cancelRequested = false;
			this.progressText = isUpdate ? '계약 정보 저장 중…' : '계약 등록 중…';
			this.$setBusy(true); // 헤더 로그아웃이 확인 없이 토큰을 지우지 않도록
			try {
				const re = await this.$apiPOST(url, body);
				if (!re || re.ok === false) return; // 실패 메시지는 $apiPOST 가 alert 으로 노출
				const savedId = isUpdate ? uid : re.id;
				if (!this.isEdit) this.savedUid = savedId;
				this.persistedUid = savedId;

				const { failed, aborted, done } = await this.uploadPicked(savedId);
				// 401 로 로그인 화면으로 밀려난 상태 — 알림·saved 이벤트를 더 내보내지 않는다.
				if (aborted === 'auth') return;
				// 문구는 사용자가 시작한 작업 기준(신규 등록 중 첨부 실패 후 재시도해도 "등록").
				const word = this.isEdit ? '수정' : '등록';
				const uploadedText = this.uploadedCount > 0 ? `\n첨부파일 ${this.uploadedCount}개는 등록되었습니다.` : '';
				if (aborted === 'user') {
					alert(
						`계약은 ${word}되었습니다.${uploadedText}\n중단하여 남은 ${failed.length}개는 올리지 않았습니다.\n` +
							`남은 파일은 "등록할 파일" 목록에 그대로 있으니 다시 저장하거나 제거하세요.`
					);
					return;
				}
				if (failed.length) {
					// 계약은 저장됐으므로 팝업을 유지하고 실패한 파일만 남긴다 → 저장을 다시 눌러도
					// update 로 나가기 때문에 계약이 중복 등록되지 않는다.
					alert(
						`계약은 ${word}되었습니다.${uploadedText}\n다만 첨부파일 ${failed.length}개를 올리지 못했습니다.\n` +
							`(${failed.join(', ')})\n"등록할 파일" 목록에 남아 있으니 다시 시도하거나 제거 후 저장하세요.`
					);
					return;
				}
				alert(`${word}되었습니다.`);
				this.$emit('saved', savedId);
			} finally {
				this.saving = false;
				this.cancelRequested = false;
				this.uploadPhase = false;
				this.progressText = '';
				this.$setBusy(false);
			}
		},
	},
};
</script>

<style lang="scss">
// 두 번째 셀렉터는 전역 `.popup.md .table-wrap`(max-height: 뷰포트 기준)보다 특이도를
// 높여 이 목록의 220px 캡을 지킨다 — 캡이 풀리면 검색 결과 50행이 팝업을 밀어
// 저장 버튼이 화면 밖으로 나간다(Codex 리뷰 P1).
.ct-form--items,
.popup.md .table-wrap.ct-form--items {
	max-height: 220px;
	overflow-y: auto;
	margin-top: 4px;
}
</style>
